import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/Pagination";
import breadcrumbImage from "../../../assets/images/course/cousre.jpg";
import vector2 from "../../../assets/images/course/vector-1.png";
import DOMPurify from "dompurify";

const CoursesSection = () => {
  const [courseList, setCourseList] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [status, setStatus] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
    const [bgImage, setBgImage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetchCourses(currentPage);
        bannerimg();
  }, [currentPage]);

  const fetchCourses = async (page) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/course-list?page=${page}&limit=${itemsPerPage}`
      );
      setCourseList(res.data.data);
      setImagePath(res.data.imagePath);
      setStatus(res.data.status);
      setTotalPages(res.data.totalPages);
    } catch (error) {
      console.error("Error fetching courses:", error);
    }
  };

  const handleReadMore = (id) => {
    localStorage.setItem("courseId", id);
    navigate("/course-detail");
  };

  const onlineCourses = courseList.filter(
    (item) => item.type === "offline_course"
  );


    const bannerimg = async () => {
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BASE_URL}/home-seeting-list`
          );
    
          const baseUrl = res.data.imagePath;
          const courseImage = res.data.home_setting[0]?.course_image;
    
          // Full image URL
          const fullUrl = baseUrl + courseImage;
    
          setBgImage(fullUrl);
        } catch (error) {
          console.error("Error fetching banner:", error);
        }
      };
  return (
    <section className="course">
      <div className="page_header"></div>

      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
          <img src={bgImage} alt="Breadcrumbs bg" />
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">Courses</h1>
        </div>
      </div>

      <Container>
        <div className="courses_list py-60">
          <div className="row">
            {onlineCourses.map((item, index) => (
              <div className="col-lg-6 col-xl-6" key={index}>
                <div className="course__card mb-8">
                  <div className="course__card__content shadow_light">
                    <div className="course__card__icon">
                      <img
                        src={item?.image ? `${imagePath}${item.image}` : ""}
                        alt="course icon"
                      />
                    </div>
                    <div className="left__block">
                      <img src={item.tag} alt="" className="course_tag" />
                      <h4 className="mb-4p">{item.title}</h4>
                      <p
                        className="mb-4p desc"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(item?.description || ""),
                        }}
                      />
                      <button
                        className="educate-btn sm me-3 mb-1 ms-auto"
                        onClick={() => handleReadMore(item.id)}
                      >
                        <span className="educate-btn__curve"></span>
                        View Detail
                      </button>
                    </div>
                    <img
                      src={vector2}
                      alt="bottom_Vector"
                      className="bottom_vector"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          {totalPages > 1 && (
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
            />
          )}
        </div>
      </Container>
    </section>
  );
};

export default CoursesSection;
